var render = function render(){var _vm=this,_c=_vm._self._c;return _c('collapse-transition',[(_vm.warningAlert)?_c('div',{staticClass:"alert alert-info idle-warning text-center",attrs:{"role":"alert"}},[_c('font-awesome-icon',{staticClass:"fa-lg",attrs:{"icon":['far', 'stopwatch']}}),_vm._v(" "+_vm._s(_vm.$t('idle.message', { time: _vm.countDown }))+" ")],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }